import type { SplitterStyles } from "../../types";
import type { SxProps, Theme } from "@mui/material";

const getStyles = (): Record<SplitterStyles, SxProps<Theme>> => {
  return {
    root: {
      opacity: 0,
    },
  };
};

export default getStyles;
